import { useApi } from '~/api'
import { defineService } from '~/api/models/helpers'
import type { AssetFilters } from '~/types/filters'
import type { WithId } from '~/types/common'
import type { AuthArgs } from '~/api/models/index'

const queries = {
  getAll: {
    queryFn: () => useApi().filters.getAllFilters(),
    queryKey: () => ['allViews']
  },
  getById: {
    queryFn: (args: { id: number }) => useApi().filters.getFilterById(args.id),
    queryKey: (args: { id: number }) => ['viewById', String(args.id)]
  }
} as const

const mutations = {
  create: {
    request: (payload: Partial<AssetFilters>) => useApi().filters.createFilter(payload),
    cacheKey: (_payload: Partial<AssetFilters>) => ['allViews']
  },
  update: {
    request: ({ id, ...payload }: WithId<Partial<AssetFilters>>) => useApi().filters.updateFilter(id, payload),
    cacheKey: ({ id }: { id: number }) => [['allViews'], ['viewById', String(id)]]
  },
  delete: {
    request: (id: number) => useApi().filters.deleteFilter(id),
    cacheKey: (id: number) => [['allViews'], ['viewById', String(id)]]
  }
} as const

export type ViewService = ReturnType<typeof defineService<typeof queries, typeof mutations>>

// Views are "Saved Filters" for assets, allowing users to save and manage custom filter sets.
export const registerService = (authArgs: AuthArgs): ViewService =>
  defineService(authArgs, {
    queries,
    mutations
  })
